import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { generatePath, Link } from 'react-router-dom';
import {
    selectHasPavedRoadsAccess,
    selectToolOwnerTools,
} from '../../../../Auth/store/accountSlice';
import routes from '../../../../Common/consts/routes';
import { AvailableTabs, ProjectsTab } from '../../api/models/PojectsTabs';
import { useIsOpcoOwner } from '../../hooks/useIsOpcoOwner';
import MyProjectsGrid from '../MyProjectsGrid/MyProjectsGrid';
import OpcoProjectsGrid from '../OpcoProjectsGrid/OpcoProjectsGrid';
import OpenProjectsGrid from '../OpenProjectsGrid/OpenProjectsGrid';
import PavedRoadsProjectsGrid from '../PavedRoadsProjectsGrid/PavedRoadsProjectsGrid';
import ToolProjectsGrid from '../ToolProjectsGrid/ToolProjectsGrid';

interface TabPanelProps {
    children?: React.ReactNode;
    activeTab: ProjectsTab;
    linkedTab: ProjectsTab;
}

function TabPanel(props: TabPanelProps) {
    const { children, activeTab, linkedTab, ...other } = props;

    return (
        <div
            style={{ height: '100%' }}
            role='tabpanel'
            hidden={activeTab !== linkedTab}
            id={`project-details-tabpanel-${linkedTab}`}
            {...other}
        >
            {activeTab === linkedTab && <>{children}</>}
        </div>
    );
}

interface ProjectsTabPanelsProps {
    routeTab: ProjectsTab;
}

const ProjectsTabPanels = ({ routeTab }: ProjectsTabPanelsProps) => {
    const { isOpcoOwner } = useIsOpcoOwner();
    const toolOwnerTools = useSelector(selectToolOwnerTools);
    const isToolOwner = toolOwnerTools.length > 0;
    const hasPavedRoadsAccess = useSelector(selectHasPavedRoadsAccess);

    return (
        <Box sx={{ width: '100%' }}>
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    pl: '100px',
                    background: 'white',
                }}
            >
                <Tabs value={routeTab}>
                    <Tab
                        component={Link}
                        to={generatePath(routes.projects, {
                            tab: AvailableTabs.my,
                        })}
                        value={AvailableTabs.my}
                        label={'MY PROJECTS'}
                    />

                    <Tab
                        component={Link}
                        to={generatePath(routes.projects, {
                            tab: AvailableTabs.other,
                        })}
                        value={AvailableTabs.other}
                        label={'OTHER PROJECTS'}
                    />

                    {isOpcoOwner && (
                        <Tab
                            component={Link}
                            to={generatePath(routes.projects, {
                                tab: AvailableTabs.opco,
                            })}
                            value={AvailableTabs.opco}
                            label={'OPCO PROJECTS'}
                        />
                    )}
                    {isToolOwner && (
                        <Tab
                            component={Link}
                            to={generatePath(routes.projects, {
                                tab: AvailableTabs.tool,
                            })}
                            value={AvailableTabs.tool}
                            label={'TOOL PROJECTS'}
                        />
                    )}
                    {hasPavedRoadsAccess && (
                        <Tab
                            component={Link}
                            to={generatePath(routes.projects, {
                                tab: AvailableTabs.pavedRoads,
                            })}
                            value={AvailableTabs.pavedRoads}
                            label={'PAVED ROADS PROJECTS'}
                        />
                    )}
                </Tabs>
            </Box>
            <TabPanel activeTab={routeTab} linkedTab={AvailableTabs.my}>
                <MyProjectsGrid />
            </TabPanel>
            <TabPanel activeTab={routeTab} linkedTab={AvailableTabs.other}>
                <OpenProjectsGrid />
            </TabPanel>
            {isOpcoOwner && (
                <TabPanel activeTab={routeTab} linkedTab={AvailableTabs.opco}>
                    <OpcoProjectsGrid />
                </TabPanel>
            )}
            {isToolOwner && (
                <TabPanel activeTab={routeTab} linkedTab={AvailableTabs.tool}>
                    <ToolProjectsGrid />
                </TabPanel>
            )}
            {hasPavedRoadsAccess && (
                <TabPanel activeTab={routeTab} linkedTab={AvailableTabs.pavedRoads}>
                    <PavedRoadsProjectsGrid />
                </TabPanel>
            )}
        </Box>
    );
};

export default ProjectsTabPanels;
